var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _vm.supportModalOpen
        ? _c("Support", {
            on: {
              close: function($event) {
                _vm.supportModalOpen = false
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "accordion",
        {
          attrs: {
            title: "Se você precisar de suporte da Donamaid utilize",
            opened: true
          }
        },
        [
          _c("ul", { staticClass: "no-dots" }, [
            _c("li", [
              _vm._v(
                "\n        o nosso chat acessando a seção suporte localizado na barra de menu inferior do aplicativo\n      "
              )
            ]),
            _vm._v(" "),
            _c("li", [_vm._v("o e-mail suporte@donamaid.com")]),
            _vm._v(" "),
            _c("li", [
              _vm._v("entre em contato conosco pelo  "),
              _c(
                "a",
                {
                  attrs: {
                    href: "https://www.facebook.com/donamaidbrasil",
                    target: "_blank",
                    rel: "noopener noreferrer"
                  }
                },
                [_vm._v("facebook")]
              ),
              _vm._v(" ou  "),
              _c(
                "a",
                {
                  attrs: {
                    href: "https://www.instagram.com/donamaid",
                    target: "_blank",
                    rel: "noopener noreferrer"
                  }
                },
                [_vm._v("instagram")]
              )
            ]),
            _vm._v(" "),
            _c("h4", { staticClass: "mb-0" }, [
              _vm._v("Horário de atendimento:")
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "mt-0" }, [
              _vm._v("\n        Segunda à sexta das 8h às 18h\n        "),
              _c("br"),
              _vm._v("Sábado das 8h às 14h\n      ")
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _vm.rules
        ? _c("accordion", { attrs: { title: "Regras", opened: true } }, [
            _c("ul", [
              _c("li", [
                _vm._v(
                  "Você pode reagendar ou cancelar um pedido gratuitamente comunicando com até 24h úteis de antecedência"
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "Você pode reagendar ou cancelar entre 24h e 3h úteis de antecedência perdendo 1h de duração da sua limpeza"
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "Você não pode reagendar ou cancelar um pedido com menos de 3h úteis de antecedência. Neste caso, se o profissional não puder ser recebido em dia e hora previamente marcados, a limpeza é considerada completa e o profissional recebe o valor normalmente"
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "A responsabilidade pelo comparecimento na limpeza é do profissional autônomo escolhido, em caso de faltas, a Donamaid fará todo o possível para realizar a substituição do profissional de acordo com as preferências previamente definidas pelo cliente no momento da realização do pedido"
                )
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "accordion",
        { attrs: { title: "Produtos de limpeza", opened: true } },
        [
          _c("accordion", { attrs: { title: "do usuário cliente" } }, [
            _c("p", [
              _vm._v(
                "Você precisa fornecer utensílios que forem necessários, como:"
              )
            ]),
            _vm._v(" "),
            _c("ul", [
              _c("li", [_vm._v("Balde")]),
              _vm._v(" "),
              _c("li", [_vm._v("Vassoura")]),
              _vm._v(" "),
              _c("li", [_vm._v("Escada")]),
              _vm._v(" "),
              _c("li", [_vm._v("EPI's")]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "Outros produtos que não estejam inclusos na lista de produtos ou quantidades extras dos produtos fornecidos pelo profissional"
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("accordion", { attrs: { title: "do profissional autônomo" } }, [
            _c("p", [_vm._v("O profissional deve fornecer:")]),
            _vm._v(" "),
            _c("ul", [
              _c("li", [_vm._v("(500ml) Desinfetante de uso geral")]),
              _vm._v(" "),
              _c("li", [_vm._v("(200ml) Limpador multiuso")]),
              _vm._v(" "),
              _c("li", [_vm._v("(200ml) Detergente")]),
              _vm._v(" "),
              _c("li", [_vm._v("(500ml) Água sanitária")]),
              _vm._v(" "),
              _c("li", [_vm._v("(1 par) de Luvas de borracha")]),
              _vm._v(" "),
              _c("li", [_vm._v("(3) Panos de chão")]),
              _vm._v(" "),
              _c("li", [_vm._v("(3) Flanelas")]),
              _vm._v(" "),
              _c("li", [_vm._v("(1) Esponja")]),
              _vm._v(" "),
              _c("li", [_vm._v("(1) Esponja de aço")]),
              _vm._v(" "),
              _c("li", [_vm._v("(2) Sacos de lixo")])
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "Os produtos de limpeza inclusos não utilizados, permanecerão com o profissional."
              )
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "accordion",
        { attrs: { title: "Responsabilidades", opened: true } },
        [
          _c("accordion", { attrs: { title: "da Donamaid" } }, [
            _c("ul", [
              _c("li", [
                _vm._v(
                  "Verificar a veracidade do cadastro dos profissionais autônomos"
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v("Manter as avaliações dos profissionais atualizadas")
              ]),
              _vm._v(" "),
              _c("li", [_vm._v("Gerir o pagamento das limpezas")]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "Fornecer suporte para comunicação entre profissional e cliente"
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("accordion", { attrs: { title: "do profissional autônomo" } }, [
            _c("ul", [
              _c("li", [_vm._v("Comparecer às limpezas no horário agendado")]),
              _vm._v(" "),
              _c("li", [_vm._v("Cumprir toda a carga horária contratada")]),
              _vm._v(" "),
              _c("li", [_vm._v("Otimizar o tempo de limpeza")]),
              _vm._v(" "),
              _c("li", [_vm._v("A qualidade da limpeza")]),
              _vm._v(" "),
              _c("li", [_vm._v("Os produtos de limpeza da lista padrão")]),
              _vm._v(" "),
              _c("li", [
                _vm._v("Alinhar com o cliente as atividades a serem realizadas")
              ]),
              _vm._v(" "),
              _c("li", [_vm._v("Seguir as prioridades de limpeza do cliente")]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "Pedir ao cliente aos 30 minutos finais da limpeza a revisão do serviço prestado"
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v("Seguir todas as regras do aplicativo Donamaid")
              ])
            ])
          ]),
          _vm._v(" "),
          _c("accordion", { attrs: { title: "do usuário cliente" } }, [
            _c("ul", [
              _c("li", [
                _vm._v(
                  "\n          Pagar o boleto antes do vencimento e enviar o comprovante de pagamento através de\n          "
                ),
                _c(
                  "b",
                  {
                    staticClass: "pointer",
                    on: { click: _vm.openSupportProofOfPayment }
                  },
                  [_vm._v("ticket")]
                ),
                _vm._v(
                  " com até 48h úteis antes da limpeza se a compra ocorrer com menos de 4 dias úteis de antecedência.\n        "
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "Prover o acesso do profissional ao local da limpeza no horário agendado com tolerância de atraso do cliente de até 30 minutos"
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "Ao início da limpeza, alinhar com o profissional todas as atividades a serem realizadas no tempo contratado, estabelecendo as prioridades"
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "Ser sincero(a) durante a limpeza quando questionado(a) pelo profissional ou ser proativo sobre a qualidade do serviço prestado"
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "Fazer avaliação sincera e descritiva do profissional autônomo pelo formulário de avaliação recebido por e-mail ao final da limpeza"
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "Solicitar horas extras de limpeza, caso necessário, pelos canais de atendimento Donamaid"
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "Notificar pelos canais de atendimento Donamaid quando permitida a saída do profissional antes do término acordado"
                )
              ])
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-64d3956a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64d3956a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Shared/CheckoutMobile/FAQ.vue
// module id = null
// module chunks = 